// extracted by mini-css-extract-plugin
export default {"container":"ZE-z","modal":"_E-z","dimensions":"aF-z","brandName":"bF-z","productName":"cF-z","labelValue":"dF-z","recipientEmail":"eF-z","recommendedFit":"fF-z","hiddenField":"gF-z"};